import WonderType from "@/roc/wonders/base/WonderType";
import WonderKind from "@/roc/wonders/base/WonderKind";
import WonderOwner from "@/roc/wonders/base/WonderOwner";
import Effects from '@/roc/effects/Effects';
import PassiveAura from '@/roc/effects/PassiveAura/PassiveAura';
import PassiveAuraType from '@/roc/effects/PassiveAura/PassiveAuraType';
import EffectAmount from '@/roc/effects/EffectAmount';
import Synergy from '@/roc/wonders/base/Synergy';
import EraType from '@/roc/era/EraType';

const LightHouseOfAlexandria = {
  id: '57',
  name: 'Lighthouse of Alexandria',
  era: EraType.bronzeAge,
  icon: 'loa',
  minLevel: 1,
  maxLevel: 30,
  type: WonderType.ANCIENT_WORLD,
  kind: WonderKind.STATUE | WonderKind.NAVAL,
  kindMultiplier: 1,
  owner: WonderOwner.CAPITAL,
  effects: Effects.create([
    new PassiveAura(
      PassiveAuraType.TRADE_OFFER_MOD,
      EffectAmount.asPerLevel([
        5.0,
        7.0,
        8.3,
        9.4,
        10.3, // 5
        11.1,
        11.8,
        12.4,
        12.9,
        13.5, // 10
        14.0,
        14.4,
        14.8,
        15.2,
        15.6, // 15
        16.0,
        16.4,
        16.7,
        17.0,
        17.3, // 20
        17.6,
        17.9,
        18.2,
        18.5,
        18.7, // 25
        19.0,
        19.3,
        19.5,
        19.7,
        20.0  // 30
      ]),
      '%'
    ),
    new PassiveAura(
      PassiveAuraType.GRANTS_TRADE_WORKER,
      EffectAmount.asCallbackWithLevel(
        function (level) {
          if (level === 30) {
            return 3;
          }
          if (level >= 15) {
            return 2;
          }
          return 1;
        }
      ),
    ),
  ]),
  synergies: [
    {
      effectIndex: 0,
      mod: Synergy.asFlat(5.0).withKind(WonderKind.NAVAL),
      effect: null,
    }
  ],
};

export default LightHouseOfAlexandria;
